import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=163e46ab&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"
import style0 from "./TicketDetails.vue?vue&type=style&index=0&id=163e46ab&prod&scoped=true&lang=css"
import style1 from "./TicketDetails.vue?vue&type=style&index=1&id=163e46ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e46ab",
  null
  
)

export default component.exports